import api from '@/api/proxyWeb/clients'

export default { 

    get({ commit, state }) {

        commit('setCurrentClient', null)

        return new Promise(resolve => {

            api.get(state.currentId)
                .then(client => {
                    commit('setCurrentClient', client)
                    resolve(client)
                })
            })      
    },

    getAddresses({ commit, state }) {

        commit('setClientAddresses', null)        

        return new Promise(resolve => {
            
            api.getAddresses(state.currentId)
                .then(addresses => {
                    commit('setClientAddresses', addresses)
                    resolve(addresses)
                })
            })
    },

    getAll({ commit }) {

        commit('setClients', null)

        return new Promise(resolve => {

            api.getAll()
                .then(clients => {
                    commit('setClients', clients)
                    resolve(clients)
                })
            })      
    }
}